export const paymentSteps = [
  { step: 1, description: 'Отсканируй QR-код смартфоном' },
  { step: 2, description: 'Подтверди оплату в\u00A0мобильном приложении своего банка' },
  { step: 3, description: 'Готово!' },
]
